function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo } from 'react';
import { injectIntl } from 'react-intl';
import styles from './InlineDrawer.module.scss';
import cs from 'classnames';
import en from './locales/InlineDrawer.en.json';
import { WmButton } from '@watermarkinsights/ripple-react';
import I18n from '../I18n/I18n/I18n';
import uuid from 'uuid/v4';
import normalizeLocaleData from '../utils/i18n/normalizeLocaleData';
import { withAdditionalIntl } from '../I18n/AdditionalIntl/AdditionalIntl';
import compose from '../utils/compose';
var messages = normalizeLocaleData(en, '@dm/components.inline-drawer');
// TODO:
// 1. aria-hidden content when closed?
// 2. aria tags for markup???

function InlineDrawer(_ref) {
  var className = _ref.className,
    children = _ref.children,
    icon = _ref.icon,
    onClose = _ref.onClose,
    onOpen = _ref.onOpen,
    open = _ref.open,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'left' : _ref$position,
    title = _ref.title,
    header = _ref.header,
    openButton = _ref.openButton,
    closeButton = _ref.closeButton,
    width = _ref.width,
    intl = _ref.intl;
  var id = useMemo(function () {
    return uuid();
  }, []);
  var transitions = _defineProperty(_defineProperty({}, styles.open, open), styles.close, !open);
  var positions = _defineProperty(_defineProperty({}, styles.left, position === 'left'), styles.right, position === 'right');
  var headerComponent = useMemo(function () {
    if (header) {
      var HeaderComp = header;
      return /*#__PURE__*/React.createElement(HeaderComp, null);
    } else if (title) {
      if (icon) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
          className: cs(icon, styles.icon)
        }), /*#__PURE__*/React.createElement(I18n, {
          i18n: title
        }));
      }
      return /*#__PURE__*/React.createElement(I18n, {
        i18n: title
      });
    }
    return null;
  }, [header, title, icon]);
  var defaultButton = useMemo(function () {
    return /*#__PURE__*/React.createElement(WmButton, {
      "aria-controls": id,
      buttonType: "navigational",
      tooltip: intl.formatMessage({
        id: "@dm/components.inline-drawer.".concat(open ? 'close' : 'open', "-label")
      }, {
        label: title
      }),
      icon: "f13d",
      tooltipPosition: "bottom",
      className: cs(styles.button, transitions, positions),
      onClick: open ? onClose : onOpen
    });
  }, [title, open, onClose, onOpen, id, transitions, positions, intl]);
  var buttonComponent = useMemo(function () {
    if (!open && openButton) {
      //open button
      var OpenButtonComponent = openButton;
      return /*#__PURE__*/React.createElement(OpenButtonComponent, {
        id: id,
        onOpen: onOpen,
        transitions: transitions,
        positions: positions
      });
    }
    if (open && closeButton) {
      //close button
      var CloseButtonComponent = closeButton;
      return /*#__PURE__*/React.createElement(CloseButtonComponent, {
        id: id,
        onClose: onClose,
        transitions: transitions,
        positions: positions
      });
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, defaultButton);
  }, [defaultButton, openButton, closeButton, open, id, onClose, onOpen, positions, transitions]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    role: "dialog",
    "aria-expanded": open,
    "aria-labelledby": "".concat(id, "-title"),
    className: "".concat(cs(styles.container, transitions, positions)).concat(className ? " ".concat(className) : ''),
    style: open ? {
      width: width
    } : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.header, " inlineDrawer-header")
  }, /*#__PURE__*/React.createElement("h2", {
    id: "".concat(id, "-title"),
    className: cs(styles.title, transitions)
  }, headerComponent), /*#__PURE__*/React.createElement("div", {
    className: cs(styles.buttonContainer)
  }, buttonComponent)), /*#__PURE__*/React.createElement("div", {
    "aria-hidden": !open,
    className: "".concat(cs(styles.contentOuter), " inlineDrawer-contentOuter"),
    style: open ? {
      width: width
    } : undefined,
    tabIndex: open ? undefined : -1
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(cs(styles.contentInner, transitions), " inlineDrawer-contentInner"),
    style: {
      width: width,
      left: open || position === 'right' ? 0 : "calc(80px - ".concat(width, ")")
    }
  }, children)));
}
var enhanced = compose(withAdditionalIntl(messages), injectIntl)(InlineDrawer);
export default enhanced;